
import { useEffect, useRef } from 'react';
import '../styles/TraceModal.css';
import ReactMarkdown from "react-markdown";

export default function TraceModal({
  open,
  onClose,
  title,
  tracedata
}) {
  const modalRef = useRef(null);

  useEffect(() => {
    if (!open) return;
    const handleKeyDown = (e) => {
      if (e.key === 'Escape') onClose?.();
    };
    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, [open, onClose]);

  useEffect(() => {
    if (open === true && modalRef.current) {
      modalRef.current.focus();
    }
    // console.log("modal", tracedata)

  }, [open]);

  if (!open) return null;


  const pairs = [];
  if (tracedata) {
    for (let i = 0; i < tracedata.length; i += 2) {
      const left = tracedata[i];
      const right = tracedata[i + 1];
      const thinking = left?.type === 'thinking' ? left
        : right?.type === 'thinking' ? right
          : null;

      const action = left?.type === 'response' || left?.type === 'action' ? left
        : right?.type === 'response' || right?.type === 'action' ? right
          : null;

      pairs.push({ key: `${i}-${i + 1}`, thinking, action });
    }
  }

  return (
    <div className="clm-backdrop-trace" onClick={onClose} aria-hidden="true">
      <div
        className="clm-enter-trace"
        onClick={(e) => e.stopPropagation()}
        tabIndex={-1}
      >
        <button className="clm-close-btn-trace" onClick={onClose}></button>
        <div className='modal-contain'>
          <h4 className='modal-title'>{title}</h4>
          {/* <div className='trace-log-body'>
            {pairs.map(({ key, thinking, action }) => (
              <div className="row m-0 p-0" key={key}>
                <div className="col-sm-6">
                  <div className='trace-sub'>
                    <div><h5 className="content-header ">Thought process</h5></div>
                    <div className='left-item'></div>
                  </div>
                  <div className="content-box thinking">
                    <ReactMarkdown>{thinking?.content || '—'}</ReactMarkdown>
                  </div>
                </div>
                <div className="col-sm-6">
                  <div className='trace-sub'>
                    <div> <h5 className="content-header ">Action</h5></div>
                    <div className='right-item'></div>
                  </div>
                  <div className="content-box action">
                    <ReactMarkdown>{action?.content || '—'}</ReactMarkdown>
                  </div>
                </div>
              </div>
            ))}
          </div> */}
          <div className="trace-log-body">
            {pairs && pairs.length > 0 ? (
              pairs.map(({ key, thinking, action }) => (
                <div className="row m-0 p-0" key={key}>
                  <div className="col-sm-6">
                    <div className="trace-sub">
                      <div><h5 className="content-header">Thought process</h5></div>
                      <div className="left-item"></div>
                    </div>
                    <div className="content-box thinking">
                      <ReactMarkdown>{thinking?.content || "—"}</ReactMarkdown>
                    </div>
                  </div>
                  <div className="col-sm-6">
                    <div className="trace-sub">
                      <div><h5 className="content-header">Action</h5></div>
                      <div className="right-item"></div>
                    </div>
                    <div className="content-box action">
                      <ReactMarkdown>{action?.content || "—"}</ReactMarkdown>
                    </div>
                  </div>
                </div>
              ))
            ) : (
              <p className="no-trace">Trace data not found.</p>
            )}
          </div>

        </div>
      </div>
    </div>
  );
}
